import { defineStore } from 'pinia';

export const useScanNavigationStore = defineStore('navigation', {
  state: () => ({
    allowOrderScan: false
    , allowReturnScan: false
    , pendingOrderScanResume: false
    , pendingReturnScanResume: false
  }),
  actions: {
    enableOrderScan() {
      this.allowOrderScan = true;
    },
    enableReturnScan() {
      this.allowReturnScan = true;
    },
    reset() {
      this.allowOrderScan = false;
      this.allowReturnScan = false;
    },
    requestOrderScanResume() {
      this.pendingOrderScanResume = true;
    },
    requestReturnScanResume() {
      this.pendingReturnScanResume = true;
    },
    clearOrderScanResume() {
      this.pendingOrderScanResume = false;
    },
    clearReturnScanResume() {
      this.pendingReturnScanResume = false;
    }
  }
});